import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getQRCodeForOrder } from '@/services/qr-code-service'

export const useQrCodeModalStore = defineStore('qrCodeModal', () => {
    // Modal state
    const modalOpen = ref(false)
    const loading = ref(false)
    const error = ref(null)
    
    // QR code data
    const qrCodeDataUrl = ref(null)
    const epcString = ref(null)
    const orderId = ref(null)

    /**
     * Opens the QR code modal and fetches QR code data for the given order
     * @param {number} orderIdValue - The order ID to generate QR code for
     */
    const openModal = async (orderIdValue) => {
        modalOpen.value = true
        loading.value = true
        error.value = null
        qrCodeDataUrl.value = null
        epcString.value = null
        orderId.value = orderIdValue

        try {
            const result = await getQRCodeForOrder(orderIdValue)
            qrCodeDataUrl.value = result.qrCodeDataUrl
            epcString.value = result.epcString
        } catch (err) {
            error.value = err.message || 'Er is een fout opgetreden bij het genereren van de QR-code'
            console.error('Error generating QR code:', err)
        } finally {
            loading.value = false
        }
    }

    /**
     * Closes the modal and clears all data
     */
    const closeModal = () => {
        modalOpen.value = false
        loading.value = false
        error.value = null
        qrCodeDataUrl.value = null
        epcString.value = null
        orderId.value = null
    }

    /**
     * Retry generating QR code for current order
     */
    const retry = async () => {
        if (orderId.value) {
            await openModal(orderId.value)
        }
    }

    return {
        // State
        modalOpen,
        loading,
        error,
        qrCodeDataUrl,
        epcString,
        orderId,
        
        // Actions
        openModal,
        closeModal,
        retry
    }
}) 